import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-752b3b1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commonquestion disabled" }, null, -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("最新信号 ")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_Table = _resolveComponent("Table")!
  const _component_WebSocket = _resolveComponent("WebSocket")!

  return (_openBlock(), _createElementBlock("section", {
    class: "stockpool light",
    style: _normalizeStyle({'background': `url(${_ctx.currentInfo.poolH5 || ''}) no-repeat 0 0 / 100%` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentInfo.content)
        ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "bottomRight",
            title: _ctx.currentInfo.content,
            overlayClassName: "tooltipstyle",
            "arrow-point-at-center": "",
            getPopupContainer: _ctx.getPopupContainer
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["title", "getPopupContainer"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, [
          _hoisted_4,
          _createElementVNode("img", {
            src: require('@/assets/stockpool/image/update.svg'),
            alt: ""
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _createElementVNode("small", null, "更新时间：" + _toDisplayString(_ctx.tradingDay[0] === '0' ? _ctx.tradingDay.slice(1) : _ctx.tradingDay), 1),
          _createElementVNode("span", {
            class: "commonfresh",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fresh && _ctx.fresh(...args)))
          })
        ]),
        _createVNode(_component_Table, {
          data: _ctx.list,
          columns: _ctx.columns,
          theme: 'light',
          bordered: false,
          scroll: { y: 'calc(100vh - 303px)', x: '100%' },
          pagination: false,
          onDbClickRow: _ctx.gotodetail
        }, null, 8, ["data", "columns", "scroll", "onDbClickRow"])
      ])
    ]),
    _createVNode(_component_WebSocket, {
      sourceData: _ctx.list,
      subonType: ['STATISTICS', 'DYNA', 'STATUS'],
      onMessage: _ctx.websocketonmessage
    }, null, 8, ["sourceData", "onMessage"])
  ], 4))
}